import React, { Component } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { 
    Button,
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    Col,
    Row
} from 'reactstrap';

// Requests
import { getClientActionRequest } from 'api/clientActions';
// Helpers
import { formatClientActionsStatus } from 'helpers/status';
class ClientActionsDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clientAction: null
        };
    }

    async componentDidMount() {
		const params = new URLSearchParams(this.props.location.search);
		const id = params.get('id');

		if (id) {
			const clientAction = await getClientActionRequest(id);

            this.setState({ 
				clientAction
            })
		} else {
			this.goTo('/client-actions')
		}
	}

    goTo = path => this.props.history.push(path);

    render() {
        const {
            clientAction
        } = this.state;

        const {
            _id,
            status,
            request,
            justification,
            recommendation,
            entries = [],
            client,
            owner,
            dateRequested,
            createdAt,
            updatedAt,
            approvedDate,
            responseFile,
            blockNumber,
            lotNumber
        } = clientAction || {};

        return (
            <>
				<div className="content">
					<Row>
                        <Col md="12">
                            <Card>
                                <CardHeader className="mb-5">
                                    <CardTitle tag="h3">
                                        Client Action Details
                                    <Button
                                        className="float-right"
                                        color="default"
                                        onClick={() => this.goTo('/client-actions')}
                                    >
                                        Back
                                    </Button>
                                    </CardTitle>
                                </CardHeader>
                                <CardBody>
                                    {
                                        !clientAction ? 
                                            <p>Loading...</p>
                                        : 
                                        <>
                                            <div className="typography-line">
                                                <div className='pb-4'>
                                                    <h4>
                                                        <span>ID</span>
                                                        {_id}
                                                    </h4>
                                                </div>
                                                
                                                <div className='pb-4'>
                                                    <h4>
                                                        <span>Status</span>
                                                        {formatClientActionsStatus(status)}
                                                    </h4>
                                                </div>

                                                <div className='pb-4'>
                                                    <h4>
                                                        <span>Client</span>
                                                        {client ? 
                                                            <Link to={`/client?id=${client._id}`}>
                                                                {`${client.first_name} ${client.last_name}`}
                                                            </Link>
                                                        :
                                                            "N/A"
                                                        }
                                                    </h4>
                                                </div>

                                                <div className='pb-4'>
                                                    <h4>
													    <span>Block Number</span>
													    {blockNumber || "N/A"}
												    </h4>
                                                </div>

                                                <div className='pb-4'>
                                                    <h4>
													    <span>Lot Number</span>
													    {lotNumber || "N/A"}
												    </h4>
                                                </div>

                                                <div className='pb-4'>
                                                    <h4>
													    <span>Processed by</span>
													    {`${owner.first_name} ${owner.last_name}`}
												    </h4>
                                                </div>						
												<div className='pb-4'>
                                                    <h4>
													    <span>Date Requested</span>
													    {moment(dateRequested).format('MM/DD/YYYY')}
												    </h4>
                                                </div>
                                                <div className='pb-4'>
                                                    <h4>
													    <span>Request</span>
													    {request}
												    </h4>
                                                </div>
												<div className='pb-4'>
                                                    <h4>
													    <span>Details</span>
													    {justification}
												    </h4>
                                                </div>
                                                <div className='pb-4'>
                                                    <h4>
													    <span>Response</span>
													    {recommendation || 'N/A'}
												    </h4>
                                                </div>

                                                <div className='pb-4'>
                                                    <h4>
                                                        <span>Approved Date</span>
                                                        {approvedDate ? moment(approvedDate).format('MM/DD/YYYY HH:mm:ss') : "N/A"}
                                                    </h4>
                                                </div>

                                                <div className='pb-4'>
                                                    <h4>
                                                        <span>File</span>
                                                        {responseFile ? <a rel="noopener noreferrer" href={responseFile} target="_blank">{responseFile}</a> : "N/A"}
                                                    </h4>
                                                </div>

                                                {entries.map((entry, index) => (
                                                    <>
                                                        <div className='pb-4'>
                                                            <h4>
                                                                <span>Response</span>
                                                                {entry.response || "N/A"}
                                                            </h4>
                                                        </div>
                                                        <div className='pb-4'>
                                                            <h4>
                                                                <span>File</span>
                                                                <a rel="noopener noreferrer" href={entry.responseFile} target="_blank">{entries[0].responseFile}</a>
                                                            </h4>
                                                        </div>
                                                        <div className='pb-4'>
                                                            <h4>
                                                                <span>Sent at</span>
                                                                {moment(entry.sent_at).format('MM/DD/YYYY HH:mm:ss') || "N/A"}
                                                            </h4>
                                                        </div>

                                                    </>
                                                ))}
                                                <div className='pb-4'>
                                                    <h4>
													    <span>Created At</span>
													    {moment(createdAt).format('MM/DD/YYYY HH:mm:ss')}
												    </h4>
                                                </div>
												<div className='pb-4'>
                                                    <h4>
													    <span>Updated At</span>
													    {moment(updatedAt).format('MM/DD/YYYY HH:mm:ss')}
												    </h4>
                                                </div>
											</div>
                                        </>
                                    }
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </>
        )
    }

}

export default ClientActionsDetails